(function(){
  function initTyper(el){
    if (el.__typer) return; el.__typer = true;
    var words = (el.getAttribute('data-words') || '').split('|').map(function(s){ return s.trim(); }).filter(Boolean);
    var txt = el.querySelector('.fb-type__txt');
    if (!words.length || !txt) return;
    var h1 = el.closest('h1');
    function reserve(){
      if (!h1) return;
      h1.style.minHeight = '';
      var keep = txt.textContent, max = 0;
      words.forEach(function(w){ txt.textContent = w; max = Math.max(max, h1.offsetHeight); });
      txt.textContent = keep;
      h1.style.minHeight = max + 'px';
    }
    reserve();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserve);
    window.addEventListener('resize', function(){ clearTimeout(el.__rt); el.__rt = setTimeout(reserve, 150); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      var k = 0;
      setInterval(function(){ k = (k + 1) % words.length; txt.textContent = words[k]; }, 2600);
      return;
    }
    var w = 0, i = words[0].length, del = true;
    function tick(){
      var word = words[w];
      if (del) {
        i--; txt.textContent = word.slice(0, Math.max(i, 0));
        if (i <= 0) { del = false; w = (w + 1) % words.length; return setTimeout(tick, 320); }
        return setTimeout(tick, 38);
      }
      i++; txt.textContent = words[w].slice(0, i);
      if (i >= words[w].length) { del = true; return setTimeout(tick, 1900); }
      return setTimeout(tick, 78);
    }
    setTimeout(tick, 2200);
  }
  function boot(){ document.querySelectorAll('.fb-type[data-words]').forEach(initTyper); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
